import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { Link } from 'react-router-dom';
import { HiEye } from 'react-icons/hi';
import { Order } from '../../Models/Order';

export default function OrderListTable({
  data,
  showOrderForm,
}: {
  data: Order[];
  showOrderForm: (order: Order) => void;
}) {
  const columnHelper = createColumnHelper<Order>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => showOrderForm(info.row.original)}
          >
            <HiEye />
          </button>
          {/* <button
          type='button'
          className='buttonCancel p-2'
          onClick={() => deleteManufacturer(info.getValue())}
        >
          <HiXCircle />
        </button> */}
        </div>
      ),
      footer: (info) => info.column.id,
      size: 25,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.requestedBy, {
      id: 'requestedBy',
      header: 'Request',
      // cell: (info) => <i>{info.getValue()}</i>,
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.companyName, {
      id: 'companyName',
      header: 'Company',
      sortingFn: 'alphanumeric',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
